import { HttpInterceptorFn, HttpErrorResponse, HttpRequest, HttpHandlerFn } from '@angular/common/http';
import { inject } from '@angular/core';
import { PlatformAPIClientAuthorizationService } from '@services/platform-api-client-authorization.service';
import { switchMap, catchError, throwError } from 'rxjs';

export const authInterceptor: HttpInterceptorFn = (request: HttpRequest<unknown>, next: HttpHandlerFn) => {
  // Skip auth for asset requests (SVG icons, etc.)
  if (request.url.startsWith('assets/') || request.url.includes('/assets/')) {
    return next(request);
  }

  // Skip auth for SlapFive API requests when temp user data exists
  const tempUserData = sessionStorage.getItem('temp_user_data');
  if (tempUserData && request.url.includes('/activity-api')) {
    return next(request);
  }

  // Skip auth for PKCE token exchange requests
  if (request.url.includes('/oauth/token')) {
    return next(request);
  }

  const authService = inject(PlatformAPIClientAuthorizationService);
  return authService.getAccessToken().pipe(
    switchMap((token) => {
      if (!token) {
        return throwError(() => new Error('No authentication token available'));
      }
      const clonedRequest = request.clone({
        setHeaders: {
          Authorization: `Bearer ${token}`,
        },
      });

      return next(clonedRequest).pipe(
        catchError((error: HttpErrorResponse) => {
          if (error.status === 401) {
            console.debug('Token expired, clearing session');
            authService.clearSession();
          }
          return throwError(() => error);
        }),
      );
    }),
  );
};
